module.exports = __webpack_public_path__ + "img/files.3a364b0a.svg";